import { FC } from 'react';
import { IFeatureProps } from 'mod/featureV2/interface';
import { FeatureContainer } from 'mod/featureV2/FeatureContainer';
import { IFeatureSwiperToggleBanner } from 'mod/featureV2/interface/swiperToggleBanner';
import { isPhone } from 'base/utils/client';
import { ThemeSwiper } from '@base/lib/ThemeSwiper';
import { HoverTogglePic } from '@base/snippets/HoverTogglePic';

type IProps = IFeatureProps<IFeatureSwiperToggleBanner> & {
    renderBanner?: (bannerProps: any) => any;
};

export const FeatureSwiperToggleBanner: FC<IProps> = props => {
    const { feature } = props;
    const {
        config: {
            width,
            height,
            spaceBetweenColumns = isPhone ? 20 : 24,
            fullScreen = false,
            centeredSlides = false,
            loop = false,
            autoplay,
            speed
        },
        list
    } = feature;

    return (
        <FeatureContainer {...props}>
            <div className="g-feature-body">
                <div className={fullScreen ? "wrapper-large" : "g-wrapper"}>
                    <ThemeSwiper
                        loop={loop}
                        autoplay={autoplay}
                        centeredSlides={centeredSlides}
                        slidesPerView={'auto'}
                        speed={speed}
                        spaceBetween={spaceBetweenColumns}
                        pagination={false}
                        navigation={!isPhone && !autoplay}
                        navigationHideWhenDisabled
                        list={list}
                        render={item => {
                            const { bgColor, large, ...rest } = item;
                            return (
                                <HoverTogglePic
                                    className={'g-banner'}
                                    {...rest}
                                    background={bgColor}
                                    width={width}
                                    height={height}
                                    fixed
                                />
                            )
                        }}
                    />
                </div>
            </div>
        </FeatureContainer>
    )
};
